jQuery(document).ready(function() {

// Shop pay button addition
jQuery('#product-form-installment').appendTo(jQuery('.shoppay-info'));

  // Display of payment slider based on currency
  if (jQuery('.product')[0]) {
     setTimeout(function() { 
      var chosenLang = jQuery('#country_code').find(":selected").text();
      //alert(chosenLang);
      var str2 = "GBP";
      if(chosenLang.indexOf(str2) != -1){
          console.log(str2 + " found");
        jQuery('.payment-set-slider').addClass('show-slider-opt');
      }
      }, 4000); 
  }
  
  var contain, oriHeight;
    contain = jQuery('.collection-banner--description');
    oriHeight = contain.height();
  
  if( jQuery('.collection-banner--description').length )       {
    if (jQuery(".search").length){}else{

        contain.addClass('restrict-cont').attr("seth", oriHeight + 'px').after('<div class="read-more">Read <span>more</span></div>').attr("newh", contain.height() + 'px');
    }
   // alert(oriHeight);
}


jQuery(".read-more").click(function(){
  //contain = jQuery('.collection-banner--description');
  //contain.toggleClass("restrict-cont");
   if (contain.height() > oriHeight - 20) {
           contain.animate({height: contain.attr("newh")});
       jQuery('.read-more span').text('more');
       jQuery('.read-more').removeClass('read-active');
           }
        else if (contain.height() < oriHeight) {
           contain.animate({height: oriHeight});
          jQuery('.read-more span').text('less');
          jQuery('.read-more').addClass('read-active');
          
           }
});

});

window.onload = function(){ 
if (jQuery('.cart-section')[0]) {
     setTimeout(function() { 
//alert('true');
         jQuery('.afterpay-paragraph').addClass('tet');
      }, 4000); 


};
};
$(document).ready(function(){
$('.afterpay-paragraph').remove();
});

// Pay options carousel - options
jQuery('.owl-pay').owlCarousel({
    loop:false,
    margin:10,
    nav:false,
  dots:false,
  autoplay:true,
    autoplayTimeout:7500,
    autoplayHoverPause:true,
  items:1

});
// Pay options carousel - custom next and previous buttons
jQuery('.customPrevBtn').click(function() {
    jQuery('.owl-pay').trigger('prev.owl.carousel');
});
jQuery('.customNextBtn').click(function() {
    jQuery('.owl-pay').trigger('next.owl.carousel');
});

// Pay options carousel - Trigger restart of carousel
window.onload = function(){ 
setTimeout(function() { 
       jQuery('.owl-pay').trigger('to.owl.carousel', [0]);
  }, 15000);
setTimeout(function() { 
       jQuery('.owl-pay').trigger('to.owl.carousel', [0]);
  }, 30000);
setTimeout(function() { 
       jQuery('.owl-pay').trigger('to.owl.carousel', [0]);
  }, 45000);
};

